<template>
    <v-menu
        ref="menu"
        v-model="periodMenu"
        :close-on-content-click="false"
        :return-value.sync="period"
        transition="scale-transition"
        offset-y
        :class="wrapperClass"
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-row v-if="checkbox" align="center">
                <v-checkbox
                    v-model="enablePeriodFilter"
                    class="shrink mr-2 mt-0 period-selector-checkbox"
                >
                    <template v-if="!enablePeriodFilter" v-slot:label>
                        <div>
                            Filtrare perioada
                        </div>
                    </template>
                </v-checkbox>
                <v-btn
                    v-if="enablePeriodFilter"
                    :class="buttonClass"
                    v-bind="attrs"
                    v-on="on">
                    Perioada {{ periodText }}
                </v-btn>
            </v-row>
            <v-btn
                v-else
                :class="buttonClass"
                v-bind="attrs"
                v-on="on">
                Perioada {{ periodText }}
            </v-btn>
        </template>
        <v-date-picker
            v-model.lazy="period"
            range
        >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="periodMenu = false"
            >
                Anulare
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.menu.save(period)"
            >
                Filtrare
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script>
    import debounce from 'lodash/debounce'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("filter");
    export default {
        props: {
            value: {
                type: Array,
                default () {
                    return [window.moment().toISOString(), window.moment().toISOString()]
                }
            },
            wrapperClass: {
                type: [String, Array, Object],
                default() {
                    return 'py-0'
                }
            },
            buttonClass: {
                type: [String, Array, Object],
                default() {
                    return ''
                }
            },
            checkbox: {
                type: Boolean,
                default () {
                    return true
                }
            }
        },
        data: function () {
            return {
                enablePeriodFilter: undefined,
                period: this.value,
                periodMenu: false,
            }
        },
        watch: {
            enablePeriodFilter : {
                handler(val) {
                    this.$store.commit('filter/setPeriodFilterActive', !!val)
                    setTimeout(() => this.$emit('input', val ? this.period : []), 500)
                }
            },
            period: {
                handler: debounce(function (val) {
                    if (this.enablePeriodFilter) {
                        if (val.length === 2) {
                            this.$store.commit('filter/setPeriod', val)
                            this.$emit('input', val)
                        }
                    } else {
                        this.$emit('input', [])
                    }
                }, 500)
            }
        },
        computed: {
            ...mapGetters({
                getPeriod: "getPeriod",
                isPeriodFilterActive: "isPeriodFilterActive"
            }),
            periodText() {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            }
        },
        mounted() {
            if (this.checkbox) {
                this.enablePeriodFilter = this.isPeriodFilterActive(false)
            } else {
                this.enablePeriodFilter = true
            }
            this.period = this.getPeriod(this.value)
        }
    }
</script>

<style lang="scss">
    .v-input{
        &.period-selector-checkbox {
            .v-input__control {
                .v-input__slot {
                    margin: 20px 0 0 10px;
                }
            }
        }
    }
</style>
